import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { ecsEntityContentExtension, amazonEcsApi } from './extensions';
import { rootRouteRef } from '../routes';
/**
 * @alpha
 */
export const amazonEcsPlugin = createFrontendPlugin({
    pluginId: 'amazon-ecs',
    routes: {
        index: rootRouteRef
    },
    extensions: [ecsEntityContentExtension, amazonEcsApi],
});